import { Badge } from "@/components/ui/badge";
import { Calendar, Clock, ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";

interface ArticleCardProps {
  id: string;
  title: string;
  excerpt: string;
  category: string;
  readTime: string;
  publishedAt: string;
  imageUrl?: string | null;
  featured?: boolean;
  slug: string;
}

const ArticleCard = ({ 
  id,
  title, 
  excerpt, 
  category, 
  readTime, 
  publishedAt, 
  imageUrl, 
  featured = false,
  slug
}: ArticleCardProps) => {
  return (
    <Link to={`/article/${slug}`} className="block">
      <article className="group cursor-pointer">
      <div className="bg-card overflow-hidden shadow-card hover:shadow-elegant transition-all duration-300 border border-border/50 h-full flex flex-col">
        <div className="relative overflow-hidden h-48">
          <img 
            src={imageUrl || '/placeholder.svg'} 
            alt={title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
            width="366"
            height="192"
            loading="lazy"
          />
          <div className="absolute top-4 left-4">
            <Badge variant="secondary">{category}</Badge>
          </div>
          <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
          <ArrowUpRight className="absolute top-4 right-4 h-5 w-5 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        </div>
        
        <div className="p-6 flex-1 flex flex-col">
          <h3 className="font-semibold mb-3 line-clamp-2 group-hover:text-primary transition-colors text-lg">
            {title}
          </h3>
          
          <p className="text-muted-foreground mb-4 line-clamp-3 text-sm flex-1">
            {excerpt}
          </p>
          
          <div className="flex items-center justify-between text-xs text-muted-foreground">
            <div className="flex items-center space-x-4">
              <div className="flex items-center space-x-1">
                <Calendar className="h-3 w-3" />
                <span>{publishedAt}</span>
              </div>
              <div className="flex items-center space-x-1">
                <Clock className="h-3 w-3" />
                <span>{readTime} read</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </article>
  </Link>
  );
};

export default ArticleCard;